// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as RefundsRouteImport } from './routes/refunds'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CheckoutSuccessRouteImport } from './routes/checkout.success'
import { Route as AppIndexRouteImport } from './routes/app.index'
import { Route as AppToolsRouteImport } from './routes/app.tools'
import { Route as AppQaRouteImport } from './routes/app.qa'
import { Route as AppProfileRouteImport } from './routes/app.profile'
import { Route as AppMatchRouteImport } from './routes/app.match'
import { Route as AppLearningQueueRouteImport } from './routes/app.learning-queue'
import { Route as AppLearningRouteImport } from './routes/app.learning'
import { Route as AppJobsRouteImport } from './routes/app.jobs'
import { Route as AppJdsRouteImport } from './routes/app.jds'
import { Route as AppInterviewRouteImport } from './routes/app.interview'
import { Route as AppGoalsRouteImport } from './routes/app.goals'
import { Route as AppGenerateRouteImport } from './routes/app.generate'
import { Route as AppFounderInsightsRouteImport } from './routes/app.founder-insights'
import { Route as AppCareerPathRouteImport } from './routes/app.career-path'
import { Route as AppBillingRouteImport } from './routes/app.billing'
import { Route as AppAutofillRouteImport } from './routes/app.autofill'
import { Route as AppApplicationsRouteImport } from './routes/app.applications'
import { Route as AppJobsIndexRouteImport } from './routes/app.jobs.index'
import { Route as AppJobsJobIdRouteImport } from './routes/app.jobs.$jobId'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const RefundsRoute = RefundsRouteImport.update({
            id: '/refunds',path: '/refunds',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
            id: '/checkout/success',path: '/checkout/success',getParentRoute: () => rootRouteImport
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRoute
          })
const AppToolsRoute = AppToolsRouteImport.update({
            id: '/tools',path: '/tools',getParentRoute: () => AppRoute
          })
const AppQaRoute = AppQaRouteImport.update({
            id: '/qa',path: '/qa',getParentRoute: () => AppRoute
          })
const AppProfileRoute = AppProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AppRoute
          })
const AppMatchRoute = AppMatchRouteImport.update({
            id: '/match',path: '/match',getParentRoute: () => AppRoute
          })
const AppLearningQueueRoute = AppLearningQueueRouteImport.update({
            id: '/learning-queue',path: '/learning-queue',getParentRoute: () => AppRoute
          })
const AppLearningRoute = AppLearningRouteImport.update({
            id: '/learning',path: '/learning',getParentRoute: () => AppRoute
          })
const AppJobsRoute = AppJobsRouteImport.update({
            id: '/jobs',path: '/jobs',getParentRoute: () => AppRoute
          })
const AppJdsRoute = AppJdsRouteImport.update({
            id: '/jds',path: '/jds',getParentRoute: () => AppRoute
          })
const AppInterviewRoute = AppInterviewRouteImport.update({
            id: '/interview',path: '/interview',getParentRoute: () => AppRoute
          })
const AppGoalsRoute = AppGoalsRouteImport.update({
            id: '/goals',path: '/goals',getParentRoute: () => AppRoute
          })
const AppGenerateRoute = AppGenerateRouteImport.update({
            id: '/generate',path: '/generate',getParentRoute: () => AppRoute
          })
const AppFounderInsightsRoute = AppFounderInsightsRouteImport.update({
            id: '/founder-insights',path: '/founder-insights',getParentRoute: () => AppRoute
          })
const AppCareerPathRoute = AppCareerPathRouteImport.update({
            id: '/career-path',path: '/career-path',getParentRoute: () => AppRoute
          })
const AppBillingRoute = AppBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AppRoute
          })
const AppAutofillRoute = AppAutofillRouteImport.update({
            id: '/autofill',path: '/autofill',getParentRoute: () => AppRoute
          })
const AppApplicationsRoute = AppApplicationsRouteImport.update({
            id: '/applications',path: '/applications',getParentRoute: () => AppRoute
          })
const AppJobsIndexRoute = AppJobsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppJobsRoute
          })
const AppJobsJobIdRoute = AppJobsJobIdRouteImport.update({
            id: '/$jobId',path: '/$jobId',getParentRoute: () => AppJobsRoute
          })





const AppJobsRouteChildren = {
  AppJobsJobIdRoute: AppJobsJobIdRoute,AppJobsIndexRoute: AppJobsIndexRoute
}

const AppJobsRouteWithChildren = AppJobsRoute._addFileChildren(AppJobsRouteChildren)



const AppRouteChildren = {
  AppApplicationsRoute: AppApplicationsRoute,AppAutofillRoute: AppAutofillRoute,AppBillingRoute: AppBillingRoute,AppCareerPathRoute: AppCareerPathRoute,AppFounderInsightsRoute: AppFounderInsightsRoute,AppGenerateRoute: AppGenerateRoute,AppGoalsRoute: AppGoalsRoute,AppInterviewRoute: AppInterviewRoute,AppJdsRoute: AppJdsRoute,AppJobsRoute: AppJobsRouteWithChildren,AppLearningRoute: AppLearningRoute,AppLearningQueueRoute: AppLearningQueueRoute,AppMatchRoute: AppMatchRoute,AppProfileRoute: AppProfileRoute,AppQaRoute: AppQaRoute,AppToolsRoute: AppToolsRoute,AppIndexRoute: AppIndexRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRoute: AppRouteWithChildren,LoginRoute: LoginRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,RefundsRoute: RefundsRoute,SignupRoute: SignupRoute,SupportRoute: SupportRoute,TermsRoute: TermsRoute,CheckoutSuccessRoute: CheckoutSuccessRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)